/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class TagPostureTagCoverage {
    getFixupPrototypeFunction() { return TagPostureTagCoverage.fixupPrototype; }

    static newInstance(model: Partial<TagPostureTagCoverage>): TagPostureTagCoverage {
        let obj = Object.assign(new TagPostureTagCoverage(), model);
        TagPostureTagCoverage.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<TagPostureTagCoverage>): TagPostureTagCoverage {
        if (!model) return null;
        return TagPostureTagCoverage.newInstance(<TagPostureTagCoverage> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: TagPostureTagCoverage) {
        if (!obj) return;

        models.TagPostureTagCoverage.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: TagPostureTagCoverage): boolean {
        Object.setPrototypeOf(obj, TagPostureTagCoverage.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.resource_counts) {
            models.TagPostureSummaryCount.fixupPrototype(this.resource_counts);
        }
    }

    /**
     * Tag key
     */
    tag: string;

    /**
     * Counts of resources for this tag
     */
    resource_counts: models.TagPostureSummaryCount;

}
